import { Button, Dialog } from 'construct-ui';
import * as PIXI from 'pixi.js';
import CanvasModel from "../../../../models/custom-vision/custom-vision.canvas.model";
import tagModel from "../../../../models/custom-vision/custom-vision.tags.model";
import trainingImageModel from "../../../../models/custom-vision/custom-vision.training-images.model";
import ViewBase from '../../../view-base.view';
import CommonFooterComponent from '../common-footer.component';
import CVTagsListView from '../cvtags/custom-vision.tags-list.view';

export default function CVTrainingImagesAddView() {
  ViewBase.call(this);

  let isPopupAssignTagOpened = false;
  let isPopupListTagsOpened = false;
  let selectedProjectId = 0;

  let inputDataModel = {
    availableTags: [],
    selectedTagId: 0,
    selectedTagName: '',
    selectedFile: null,
    assignedTags: [],
    imageWidth: 0,
    imageHeight: 0
  };

  let app = new PIXI.Application({
    width: 700,
    height: 500,
    backgroundColor: 0xffffff
  });

  let onSelectionBoxConfirmed = () => {
    isPopupAssignTagOpened = true;
    m.redraw();
  }

  let canvasModel = new CanvasModel(app, onSelectionBoxConfirmed);

  let canvas = null;

  let imagePreview = null;

  let onPopupClose = (e) => { };
  let onSaveComplete = (e) => { };

  let _cancel = (e) => {
    onPopupClose(e);
  }

  let _save = (e) => {
    this.showLoading();

    inputDataModel.imageWidth = canvasModel.getImageWidth();
    inputDataModel.imageHeight = canvasModel.getImageHeight();

    trainingImageModel.uploadNewImageWithTags(
      (result) => {
        this.hideLoading();
        onSaveComplete(result);
      },
      (error) => {
        this.hideLoading();
        this.handleError(error);
      },
      selectedProjectId,
      inputDataModel
    );
  }

  let _loadTags = () => {
    tagModel.getTagsList(
      _tagsListSuccessCallBack,
      _tagsListErrorCallBack,
      selectedProjectId,
      "", 1, 0
    );
  }

  let _tagsListSuccessCallBack = (result) => {
    let list = result.data;
    if (list == null) {
      list = [];
    }

    inputDataModel.availableTags = [];
    inputDataModel.availableTags.push({ code: "0", name: this.getText("LT00000010", "Choose...") });
    for (var i = 0; i < list.length; i++) {
      inputDataModel.availableTags.push({ code: list[i].id, name: list[i].name });
    }
  }

  let _tagsListErrorCallBack = (error) => {
    inputDataModel.availableTags = [];
    inputDataModel.availableTags.push({ code: "0", name: this.getText("LT00000010", "Choose...") });
  }

  let _assignTag = (e) => {

    if (inputDataModel.selectedTagId == 0) {
      this.showWarningMessage(
        this.getText("LT00000010XX", "Please choose a tag to assign to the selection area of the picture."),
        this.getText("LT00000010XX", "No Tag Specified")
      );

      canvasModel.resetSelectionBox();
      isPopupAssignTagOpened = false;

      return;
    }

    let taggingResult = canvasModel.confirmSelectionBox(inputDataModel.selectedTagName);

    inputDataModel.assignedTags.push(
      {
        tagId: inputDataModel.selectedTagId,
        tagName: inputDataModel.selectedTagName,
        width: taggingResult.width,
        height: taggingResult.height,
        left: taggingResult.left,
        top: taggingResult.top,
        graphicalBox: taggingResult.selectionBox,
        textBackground: taggingResult.textBackground,
        graphicalText: taggingResult.text
      });

    document.getElementById('tagSelection').selectedIndex = 0;
    canvasModel.resetSelectionBox();
    inputDataModel.selectedTagId = 0;
    inputDataModel.selectedTagName = '';

    isPopupAssignTagOpened = false;
  }

  function deassignTag(index) {
    canvasModel.unconfirmSelectionBox({
      selectionBox: inputDataModel.assignedTags[index].graphicalBox,
      text: inputDataModel.assignedTags[index].graphicalText,
      textBackground: inputDataModel.assignedTags[index].textBackground
    });

    inputDataModel.assignedTags.splice(index, 1);
  }

  function deassignAllTags() {
    for (var index = inputDataModel.assignedTags.length - 1; index >= 0; index--) {
      deassignTag(index);
    }
  }

  let _showListTagsPopup = () => {
    isPopupListTagsOpened = true;
  };

  return {
    oninit: (vnode) => {

      if (vnode.attrs.onPopupClose) {
        onPopupClose = vnode.attrs.onPopupClose;
      }
      if (vnode.attrs.onSaveComplete) {
        onSaveComplete = vnode.attrs.onSaveComplete;
      }
      if (vnode.attrs.projectId) {
        selectedProjectId = vnode.attrs.projectId;

        _loadTags();
      }
    },
    onremove: (vnode) => {
      app.destroy();
    },
    view: ({ attrs }) => {

      if (canvas == null && document.getElementsByTagName("canvas").length > 0) {
        canvas = document.getElementsByTagName("canvas")[0];

        canvas.addEventListener('contextmenu', function (e) {
          e.preventDefault();

          if (e.which === 3) {
            canvasModel.resetSelectionBox();

            isPopupAssignTagOpened = false;
            m.redraw();
          }
        });
      }


      return [
        m('.row',
          m('col-md-12',
            m('.card',
              m('.card-body',
                m('form.my-form',
                  m('.row.col-md-12',
                    m('.col-md-3.mt-4',
                      m('label.form-label', this.getText("LT00000039XX", "Training Image"),
                        m('span.text-danger', "*")),
                      m('input[type="file"][id="fileElem"]', {
                        onchange: (e) => {
                          let fileSize = e.target.files[0].size;
                          if (fileSize > 4194304) {

                            this.showWarningMessage(
                              this.getText("LT00000010XX", "Please only use image with file size less than 4MB."),
                              this.getText("LT00000010XX", "Image Too Large")
                            );

                            return;
                          }

                          isPopupAssignTagOpened = false;
                          canvasModel.resetSelectionBox();

                          deassignAllTags();

                          inputDataModel.selectedFile = e.target.files[0];

                          let reader = new FileReader();
                          reader.readAsDataURL(e.target.files[0]);

                          reader.onload = (e) => {
                            imagePreview = e.target.result;
                            m.redraw();

                            var image = new Image();

                            image.onload = function () {
                              let imageWidth = this.naturalWidth;
                              let imageHeight = this.naturalHeight;

                              canvasModel.clearAllChildren();

                              canvasModel.setupSceneImage(this.src, imageWidth, imageHeight);

                              canvasModel.drawGrid();
                            }

                            // Load image.
                            image.src = imagePreview;


                          }
                        }
                      }),
                      m('label.button.btn.width-100[for="fileElem"]', this.getText("LT00000374", "Select File")),
                    ),
                    m('.col-md-6.mt-4'),
                    m('.col-md-3.mt-4', m("a", { "href": "javascript:;", onclick: () => { _showListTagsPopup() } }, [m("i", { "class": "bi bi-tag" }), m("span", "Manage Tags...")])),
                    m('.col-md-9.mt-4',
                      m("img[id='mainImage']", { "src": imagePreview, "style": "max-width: 100%; display: none;" }),
                      m('.pixiContainer', {
                        oncreate: ({ dom }) => dom.appendChild(app.view)
                      })
                    ),
                    m('.col-md-3.mt-4', [
                      isPopupAssignTagOpened && m('div', [
                        m('label.form-label', this.getText("LT00000039XX", "Tags"), m('span.text-danger', "*")),
                        m('select.form-select[id="tagSelection"]', {
                          onchange: (e) => {
                            inputDataModel.selectedTagId = parseInt(inputDataModel.availableTags[e.target.selectedIndex]["code"]);
                            inputDataModel.selectedTagName = inputDataModel.availableTags[e.target.selectedIndex]["name"];
                          }
                        },
                          inputDataModel.availableTags.map(tag => [m('option[value="' + tag["code"] + '"]', tag["name"])])
                        ),
                        m("button.btn.btn-primary[type='button']", { onclick: _assignTag, style: "width: 100%; margin-top: 6px;" }, this.getText("LT00000022XXX", "Assign Tag")),


                      ]),
                      inputDataModel.assignedTags.length > 0 && m("div", { style: "text-align: center; margin-bottom: 10px;" }, [
                        m("hr"),
                        m("span", "Assigned Tags:")
                      ]),
                      m("div", inputDataModel.assignedTags.map(
                        (tag, index) => [m('div', { style: 'margin-top: 4px;' }, [
                          m('span.badge.rounded-pill.green-bg-status', tag.tagName),
                          m('label.form-check-label', m('i.bi.bi-x-circle-fill.ms-3.text-danger',
                            {
                              style: 'cursor: pointer',
                              onclick: () => { deassignTag(index); }
                            }))
                        ])]
                      ))
                    ]),
                  ),
                )
              ),
              m(CommonFooterComponent, {
                actionHandler: _save,
                cancelHandler: _cancel,
              }),
            )
          ),
        ),
        m(Dialog, {
          isOpen: isPopupListTagsOpened,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: () => { isPopupListTagsOpened = false; _loadTags(); },
          title: this.getText("LT00000136", "Tags"),
          content: m(CVTagsListView, { projectId: selectedProjectId }),
          "class": "cui-dialog-xxl",
          footer: [

            m('.d-flex.justify-content-end',
              m(Button, {
                label: this.getText("LT00000021", "Close"),
                onclick: () => { isPopupListTagsOpened = false; _loadTags(); },
                intent: 'primary'
              })
            ),
          ]

        }),
        this.getBaseViews()
      ];
    },
  };
}
